const initialState = {
  counter: 0,
  name: "hello",
  emailAddress: "hello@example.com",
  message: "Type your message here...",
};

export default initialState;
